/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Home',
    slug: 'home',
    icon: 'HomeIcon',
    role: 1
  },
  {
    url: null,
    name: '재고 관리',
    icon: 'PackageIcon',
    submenu: [
      {
        url: '/inventory/invoices',
        name: '입출고 관리',
        slug: 'inventory-invoices',
        role: 1
      },
      {
        url: '/inventory/status',
        name: '재고 현황',
        slug: 'inventory-status',
        role: 1
      }
    ],
    role: 1
  },
  {
    url: null,
    name: '장착 관리',
    icon: 'SettingsIcon',
    submenu: [
      {
        url: '/installation/audits',
        name: '장착 심사 관리',
        slug: 'installation-audits',
        role: 1
      },
      {
        url: '/installation/completes',
        name: '장착 완료 목록',
        slug: 'installation-completes',
        role: 1
      }
    ],
    role: 1
  },
  {
    url: '/regions',
    name: '항목 관리',
    slug: 'regionss',
    icon: 'TagIcon',
    role: 5
  },
  {
    url: '/managers',
    name: '운영자 관리',
    slug: 'managers',
    icon: 'UsersIcon',
    role: 9
  }
]
